import { Navigate } from "react-router";
import BasePage from "ui/common/components/layout/BasePage/BasePage";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import AcceptTermsAndConditionsForm from "../containers/AcceptTermsAndConditionsForm/AcceptTermsAndConditionsForm";
import useAreTermsAndConditionsUpdated from "../query/useAreTermsAndConditionsUpdated";

function TermsAndConditionsPage(): JSX.Element {
    const { isLoading, areTermsAndConditionsUpdated } = useAreTermsAndConditionsUpdated();
    const areTermsAlreadyAccepted = areTermsAndConditionsUpdated && !isLoading;

    return areTermsAlreadyAccepted ? (
        <Navigate to={MainRoutes.MAIN} />
    ) : (
        <BasePage>
            <AcceptTermsAndConditionsForm />
        </BasePage>
    );
}

export default TermsAndConditionsPage;
